module.exports = "/static-assets/_next/static/images/frog-love-d026c9a1d300376bc566162bfdd877ba.png";